import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';
import { useAppDispatch, useAppSelector } from '@/redux';
import Icon from '@/components/common/iconedLinks/Icon';
import { selectPaymentProviderInfos } from '@/redux/slices/checkout.slice';
import { useEffect } from 'react';
import { loadPaymentProvider } from '@/redux/thunks/checkout/loadPaymentProvider';
import { URLS } from '@/constants/urls';

const placeholderHiphens = '- - - -';
const doubleSpace = '  ';

const HIPAY_FORM = {
  cardHolder: {
    selector: 'hipay-card-holder',
    placeholder: ''
  },
  cardNumber: {
    selector: 'hipay-card-number',
    placeholder: Array(4).fill(placeholderHiphens).join(doubleSpace)
  },
  expiryDate: {
    selector: 'hipay-expiry-date'
  },
  cvc: 'hipay-cvc'
};

export const HipayCardForm = () => {
  const { t } = useTranslation(NS.CHECKOUT);
  const dispatch = useAppDispatch();
  const hipay = useAppSelector(selectPaymentProviderInfos);

  useEffect(() => {
    dispatch(loadPaymentProvider({ paymentProvider: 'HIPAY' }));
  }, []);

  return (
    <div className="hipay-new-card" data-test-id="hipay-card-form">
      {hipay.error && (
        <h5>
          {t('payMode.contactingHipayTimeout', { ns: NS.CHECKOUT })}
        </h5>
      )}
      <form id="hipay-form">
        <h4 className="hipay-card-details tu-hipay-card-details">
          {t('payMode.cardDetails', { ns: NS.CHECKOUT })}
        </h4>
        <div>
          <div>
            <label htmlFor={HIPAY_FORM.cardHolder.selector}>{t('payMode.cardHolder', { ns: NS.CHECKOUT })}*</label>
            <div className="hostedfield form-control" id={HIPAY_FORM.cardHolder.selector}></div>
          </div>
        </div>
        <div>
          <div>
            <label htmlFor={HIPAY_FORM.cardNumber.selector}>{t('payMode.cardNumber', { ns: NS.CHECKOUT })}*</label>
            <div className="hostedfield form-control" id={HIPAY_FORM.cardNumber.selector}></div>
          </div>
        </div>
        <div>
          <div>
            <label htmlFor={HIPAY_FORM.expiryDate.selector}>{t('payMode.expiryDate', { ns: NS.CHECKOUT })}*</label>
            <div className="hostedfield form-control" id={HIPAY_FORM.expiryDate.selector}></div>
          </div>
        </div>
        <div>
          <div>
            <label htmlFor={HIPAY_FORM.cvc}>{t('payMode.cvc', { ns: NS.CHECKOUT })}*</label>
            <span className="tu-cvcTooltip">
              <Icon src={URLS.ICON_QUESTION_HELP} alt="question" id="cvcTooltip" className="icon-question" />
            </span>
            <div className="hostedfield form-control" id={HIPAY_FORM.cvc}></div>
            <div id="hipay-cvc-help" />
          </div>
        </div>
        <div id="hipay-error-message"></div>
      </form>
    </div>
  );
};

HipayCardForm.propTypes = {
  sendCardInfo: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  hipayLogin: PropTypes.string.isRequired,
  hipayPassword: PropTypes.string.isRequired,
  enableSetBrowserInfos: PropTypes.bool,
  shouldRefresh: PropTypes.bool,
  columnAllowed: PropTypes.bool
};

export default HipayCardForm;
